import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom'
import UpdateProfile from './UpdateProfile'
import { showToast } from '../../../Component/Toast';
import axios from 'axios'
import moment from 'moment'
import useClientHook from "../../../Hooks/useClientHook";
import Loader from '../../../Component/Loader'

const isDevMode = (origin) => origin && origin.includes('employee.dev.eka.io');

// `origin` comes back from the provider as an origin *key*, not a host. A tenant whose
// portal lives on a path instead of its own subdomain is keyed with the slash written as
// an underscore (hilap.adityabirla.com_user), because the key has to survive as a single
// path segment in /v1/client/:type/:origin. Put the slash back before using the value as
// a URL, or the browser tries to resolve `hilap.adityabirla.com_user` as a hostname and
// fails with ERR_NAME_NOT_RESOLVED. Only the first underscore is the separator; a
// hostname never contains one.
const portalUrl = (origin) => `https://${String(origin || '').replace('_', '/')}`;
// const isDiceOrigin = (origin) => origin && origin.includes('dice.tech');

function Index() {

    const HISTORY = useHistory();
    const { search } = useLocation()
    const { client_id, origin, provider } = useClientHook('LOGIN');

    const [onboardingConfig, setOnboardingConfig] = useState(null);
    const [configLoading, setConfigLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    const params = new URLSearchParams(search)
    const DATA = {
        code: params.get("code"),
        type: params.get("grant_type"),
        baseUrl: params.get("apiOrigin"),
        client_id
    }

    if (DATA.type !== 'setup_code') {
        HISTORY.push(`/?origin=${origin}&provider=${provider}`)
    }

    // Only fetch onboarding config for dice origins; wait for client_id (signals hook is ready)
    useEffect(() => {
        if (!client_id) return;

        if (!isDevMode(origin) || !DATA.baseUrl || !DATA.code) {
            setConfigLoading(false);
            return;
        }

        axios.get(`${DATA.baseUrl}employee/auth/v2/onboarding`, {
            params: { code: DATA.code, client_id: client_id }
        }).then(res => {
            setOnboardingConfig(res.data?.onboardingConfig || null);
        }).catch(() => {
            setOnboardingConfig(null);
        }).finally(() => {
            setConfigLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client_id]);

    const getFileUploadUrl = () => {
        if (origin && origin.includes('employee.dev.eka.io')) {
            return 'https://file.dev.eka.io/apis/v1/file';
        }
        // UAT (employee-uat.dice.tech) and PROD (employee.dice.tech)
        return 'https://file.eka.io/apis/v1/file';
    };

    const uploadFile = async (file) => {
        const fd = new FormData();
        fd.append('file', file);
        const res = await axios.post(getFileUploadUrl(), fd, {
            headers: {
                clientid: '422dc3e2-a960-4941-9a7a-af64732157b5',
                clientsecret: '9cd4ce3e-6ea6-45d7-bf92-06c9c7a69873',
            }
        });
        return res.data?.url || res.data?.fileUrl || res.data?.link || res.data?.path || res.data;
    };

    const submitForm = async (formData) => {
        let payload;
        setSubmitLoading(true);

        try {
            if (isDevMode(origin)) {
                const { dateOfBirth, gender, ...restFields } = formData;
                const dobStamp = dateOfBirth ? moment(dateOfBirth, 'YYYY-MM-DD').valueOf() : undefined;

                const fields = {};
                for (const [key, value] of Object.entries(restFields)) {
                    if (value instanceof File) {
                        fields[key] = await uploadFile(value);
                    } else if (value !== '' && value != null) {
                        fields[key] = value;
                    }
                }

                payload = {
                    avatar: '',
                    ...(dobStamp ? { dob: dobStamp } : {}),
                    ...(gender ? { gender } : {}),
                    code: DATA.code,
                    type: DATA.type,
                    client_id,
                    ...(provider ? { origin: provider } : undefined),
                    fields,
                };
            } else {
                payload = {
                    ...formData,
                    code: DATA.code,
                    type: DATA.type,
                    client_id,
                    ...(provider ? { origin: provider } : undefined),
                };
            }
        } catch {
            showToast({ type: 'error', message: 'Failed to process file. Please try again.' });
            setSubmitLoading(false);
            return;
        }

        axios.post(`${DATA.baseUrl}employee/auth/v2/onboard`, payload).then(res => {
            let r = res.data;
            if (r && r.code && r.type) {
                if (origin.includes('fedgo.dev.eka.io') || origin.includes('hilapdev.adityabirla.com') || origin.includes('hilap.adityabirla.com')) {
                    window.location.replace(`${portalUrl(origin)}/authorize?code=${r.code}&grant_type=${r.type}&apiOrigin=${DATA.baseUrl}&client_id=${DATA.client_id}`)
                } else {
                    window.location.replace(`${portalUrl(origin)}/loading?code=${r.code}&grant_type=${r.type}&apiOrigin=${DATA.baseUrl}&client_id=${DATA.client_id}`)
                }
            } else {
                showToast({ type: 'error', message: "Something went Wrong !" })
            }
        }).catch(err => {
            showToast({
                type: 'error',
                message: err.response ? err.response.data.message : "Something went Wrong !"
            })
        }).finally(() => {
            setSubmitLoading(false);
        })
    }

    if (!client_id || configLoading) {
        return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{ background: '#fff' }}><Loader /></div>
    }

    return (
        <UpdateProfile
            onboardingConfig={onboardingConfig}
            isDice={isDevMode(origin)}
            origin={origin}
            onSuccess={submitForm}
            loading={submitLoading}
        />
    )
}

export default Index;
